var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PreRenderService } from './pre-render.service';
import { Observable, BehaviorSubject, merge, of } from 'rxjs';
import { UserService } from './user.service';
import { GoogleMapsService } from './google-maps.service';
import { Filters, PositionInfo } from '../classes/user-preferences';
import { SavedSearch } from '../classes/saved-search';
import { SearchType, ViewModes, SortBy, NotificationFrequency } from '../classes/enums';
import { User } from '../classes/user';
import { HasSubscriptions } from '../components/has-subscriptions';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SearchFiltersParams } from '../classes/search-filters-params';
import { CommunicationService } from './communication.service';
import { Angulartics2 } from 'angulartics2';
import { transformAnalyticsTagForListingType } from '../shared/pipes/listing-type-analytics-tag.pipe';
import { map } from 'rxjs/operators';
import { OARegions } from '../app-config.constants';
import { ApiConfigService } from './api-config/api-config.service';
import { CookieService } from 'ngx-cookie';
import { AnalyticsService } from './analytics/analytics.service';
import { NOTIFICATION_CHECKBOX_VALUE } from '../classes/analytics-tags';
import { NeighbourhoodDetails } from '../neighbourhoods/classes/neighbourhood-details';
import { CacheService } from './cache.service';
import { Helper } from '../classes/helper';
export var THIRTY_DAYS_IN_MS = 2592000000;
var PreferencesService = /** @class */ (function (_super) {
    __extends(PreferencesService, _super);
    function PreferencesService(userService, googleMapsService, communicationService, prerenderService, http, angulartics2, appConfig, apiConfig, _cache, cookieService, analyticsService) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.googleMapsService = googleMapsService;
        _this.communicationService = communicationService;
        _this.prerenderService = prerenderService;
        _this.http = http;
        _this.angulartics2 = angulartics2;
        _this.appConfig = appConfig;
        _this.apiConfig = apiConfig;
        _this._cache = _cache;
        _this.cookieService = cookieService;
        _this.analyticsService = analyticsService;
        _this._user = new User();
        // First value is true when the geolocation function is complete, second value is if it was successful at getting a location.
        _this.doneGettingPhysicalLocation = new BehaviorSubject([false, false]);
        _this.savedLocalSavedSearches = new BehaviorSubject(false);
        _this._subjects = {
            filters: new BehaviorSubject(new Filters()),
            agentSearchFilters: new BehaviorSubject(new SearchFiltersParams()),
            officeSearchFilters: new BehaviorSubject(new SearchFiltersParams()),
            positionInfo: new BehaviorSubject(new PositionInfo()),
            moreInfoRequested: new BehaviorSubject([]),
            locale: new BehaviorSubject(null),
            viewedListings: new BehaviorSubject([]),
            recentSearches: new BehaviorSubject([]),
            savedSearches: new BehaviorSubject([]),
            nextListings: new BehaviorSubject([]),
            viewModes: new BehaviorSubject(ViewModes.GALLERY),
            gallerySorting: new BehaviorSubject(SortBy.NEWEST),
            favouriteListings: new BehaviorSubject([]),
            favouriteAgents: new BehaviorSubject([]),
            favouriteAgentDetailUrl: new BehaviorSubject(null)
        };
        _this.filtersChanged = _this._subjects.filters.asObservable();
        _this.agentSearchFiltersChanged = _this._subjects.agentSearchFilters.asObservable();
        _this.officeSearchFiltersChanged = _this._subjects.officeSearchFilters.asObservable();
        _this.positionInfoChanged = _this._subjects.positionInfo.asObservable();
        _this.favouriteListingsChanged = _this._subjects.favouriteListings.asObservable();
        _this.moreInfoRequestedChanged = _this._subjects.moreInfoRequested.asObservable();
        _this.localeChanged = _this._subjects.locale.asObservable();
        _this.viewedListingsChanged = _this._subjects.viewedListings.asObservable();
        _this.recentSearchesChanged = _this._subjects.recentSearches.asObservable();
        _this.savedSearchesChanged = _this._subjects.savedSearches.asObservable();
        _this.nextListingsChanged = _this._subjects.nextListings.asObservable();
        _this.viewModesChanged = _this._subjects.viewModes.asObservable();
        _this.gallerySortingChanged = _this._subjects.gallerySorting.asObservable();
        _this.favouriteAgentsChanged = _this._subjects.favouriteAgents.asObservable();
        _this.favouriteAgentUrlChanged = _this._subjects.favouriteAgentDetailUrl.asObservable();
        _this.addSub(_this.userService.currentUser.subscribe(function (user) {
            if (user) {
                _this._user = user;
                // Set up the preferences for the current user.
                _this.setUserPreferencesFromServer();
            }
        }));
        _this.addSub(merge(_this.filtersChanged, _this.agentSearchFiltersChanged, _this.officeSearchFiltersChanged, _this.favouriteListingsChanged, _this.moreInfoRequestedChanged, _this.localeChanged, _this.viewedListingsChanged, _this.savedSearchesChanged, _this.nextListingsChanged, _this.positionInfoChanged, _this.viewModesChanged, _this.gallerySortingChanged, _this.favouriteAgentsChanged).subscribe(function () {
            _this._user.updatedByStorage = false;
        }));
        return _this;
    }
    PreferencesService.prototype.setLocale = function (locale) {
        this._user.preferences.locale = locale;
        // console.log('preferences.service: locale changed');
        this._subjects.locale.next(locale);
    };
    PreferencesService.prototype.setViewModes = function (viewModes) {
        this._user.preferences.viewMode = viewModes;
        // console.log('preferences.service: viewModes changed - ' + viewModes);
        if (this.prerenderService.isServerMode) {
            // Ensure view mode is never map on server
            return;
        }
        this._subjects.viewModes.next(viewModes);
    };
    PreferencesService.prototype.getGallerySorting = function () {
        return this._user.preferences.gallerySorting;
    };
    PreferencesService.prototype.setGallerySorting = function (sortBy) {
        this._user.preferences.gallerySorting = sortBy;
        this._subjects.gallerySorting.next(sortBy);
    };
    PreferencesService.prototype.updateFilters = function (filters) {
        this._user.preferences.filters = Filters.clone(filters);
        // console.log('preferences.service: filters changed');
        this._subjects.filters.next(filters);
    };
    PreferencesService.prototype.getFilters = function () {
        return this._user.preferences.filters;
    };
    PreferencesService.prototype.updateSearchFilters = function (searchType, filters) {
        if (searchType === SearchType.AGENT) {
            this._user.preferences.agentSearchFilters = filters;
            this._subjects.agentSearchFilters.next(filters);
        }
        else {
            this._user.preferences.officeSearchFilters = filters;
            this._subjects.officeSearchFilters.next(filters);
        }
    };
    PreferencesService.prototype.saveUserPosition = function (positionInfo) {
        var newPosition = PositionInfo.clone(positionInfo);
        this._user.preferences.positionInfo = newPosition;
        this.cookieService.putObject(PreferencesService.COOKIE_USER_LOCATION, newPosition);
        // console.log('preferences.service: positionInfo changed - ' + JSON.stringify(positionInfo));
        this._subjects.positionInfo.next(positionInfo);
    };
    PreferencesService.prototype.toggleFavouriteListing = function (listingId, analyticsTagSuffix) {
        var favourites = this._user.preferences.favouriteListings;
        var index = favourites.indexOf(listingId);
        var wasFavorite = true;
        // already exists, remove it
        if (index >= 0)
            favourites.splice(index, 1);
        else {
            favourites.push(listingId);
            wasFavorite = false;
        }
        if (!wasFavorite) {
            this.angulartics2.eventTrack.next({
                properties: {
                    event: transformAnalyticsTagForListingType(analyticsTagSuffix, this.communicationService.listings.currentShownListingType.value)
                }
            });
        }
        // console.log('preferences.service: favourites changed');
        this._subjects.favouriteListings.next(favourites);
    };
    PreferencesService.prototype.toggleMoreInfoRequested = function (listingId) {
        var moreInfoRequested = this._user.preferences.moreInfoRequested;
        var index = moreInfoRequested.indexOf(listingId);
        // already exists, remove it
        if (index >= 0)
            moreInfoRequested.splice(index, 1);
        else
            moreInfoRequested.push(listingId);
        // console.log('preferences.service: moreInfoRequested changed');
        this._subjects.moreInfoRequested.next(moreInfoRequested);
    };
    PreferencesService.prototype.addViewedListing = function (listingId) {
        var viewedListings = this._user.preferences.viewedListings;
        // Only broadcast change if not already included
        if (viewedListings.filter(function (it) { return it.split(';')[0] === listingId; }).length === 0) {
            viewedListings.push(listingId + ';' + Date.now());
            // console.log('preferences.service: viewedListings changed');
            this._subjects.viewedListings.next(viewedListings);
        }
    };
    PreferencesService.prototype.addRecentSearch = function (search) {
        var maxRecentSearches = 5;
        var recentSearches = this._user.preferences.recentSearches;
        if (recentSearches.some(function (s) { return s === search; }))
            return;
        if (recentSearches.length >= maxRecentSearches)
            recentSearches.pop();
        recentSearches.unshift(search);
        // console.log('preferences.service: recentSearches changed');
        this._subjects.recentSearches.next(recentSearches);
    };
    PreferencesService.prototype.updateSavedSearch = function (savedSearch) {
        var index = this._user.preferences.savedSearches.findIndex(function (s) { return s.name === savedSearch.name; });
        return this.addNewSavedSearch(savedSearch.name, savedSearch.notificationsEnabled, index);
    };
    PreferencesService.prototype.updateNotificationOnSavedSearch = function (savedSearch) {
        var index = this._user.preferences.savedSearches.findIndex(function (s) { return s.name === savedSearch.name; });
        var savedSearches = this._user.preferences.savedSearches;
        if (index >= 0)
            savedSearches[index].notificationsEnabled = savedSearch.notificationsEnabled;
        this.analyticsService.eventTrack(NOTIFICATION_CHECKBOX_VALUE, savedSearch.notificationsEnabled);
        this._subjects.savedSearches.next(savedSearches);
    };
    PreferencesService.prototype.deleteSavedSearch = function (s) {
        var savedSearches = this._user.preferences.savedSearches;
        var index = savedSearches.findIndex(function (savedSearch) { return s.name === savedSearch.name; });
        savedSearches.splice(index, 1);
        this._subjects.savedSearches.next(savedSearches);
    };
    PreferencesService.prototype.deleteAllSavedSearches = function () {
        this._user.preferences.savedSearches = [];
        this._subjects.savedSearches.next([]);
    };
    PreferencesService.prototype.restoreSavedSearch = function (s) {
        this.communicationService.setCurrentListingType(s.listingCategory);
        this.saveUserPosition(s.positionInfo);
        this.updateFilters(s.filters);
    };
    PreferencesService.prototype.doesSavedSearchExist = function (name) {
        return this._user.preferences.savedSearches.some(function (s) { return s.name === name; });
    };
    PreferencesService.prototype.addNextListings = function (listings) {
        this._subjects.nextListings.next(listings);
    };
    PreferencesService.prototype.setIsWcRegion = function (addressComponents) {
        var date = new Date();
        var index = addressComponents.findIndex(function (g) { return OARegions.indexOf(g.short_name.toLowerCase()) !== -1; });
        this._user.preferences.isWCRegion = index === -1;
        this.cookieService.put(PreferencesService.COOKIE_USER_IS_WC_REGION, this._user.preferences.isWCRegion.toString(), { expires: (1000 * 60 * 60 * 24 * 30).toString() });
        this.userService.saveUserPreferences(this._user.preferences);
    };
    /**
     * Geocode based on a search string, set zoom level from helper, get bounds, then set map to that
     * @param searchString the string being used for geocoding (typically from a search bar or URL path)
     * @param clientSide whether this request should use the client-side or server-side API. Use client-side for
     * things like user searches and use server-side for frequently repeated requests like city-province strings
     */
    PreferencesService.prototype.centerMapThroughGeocode = function (searchString, clientSide) {
        return __awaiter(this, void 0, void 0, function () {
            var results, latLng, zoomLevel, bounds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!clientSide) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getClientSideGeocode(searchString)];
                    case 1:
                        results = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.googleMapsService.performBasicGeocode(searchString)];
                    case 3:
                        results = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (results && results.isQuebec) {
                            this.communicationService.navigation.showSearch.next(false);
                            this.communicationService.notifications.showQuebecModal.next(true);
                            return [2 /*return*/, false];
                        }
                        this.communicationService.searching.activeSearchText.next(searchString);
                        if (results) {
                            latLng = results.location;
                            zoomLevel = results.zoom;
                            bounds = this.googleMapsService.getBoundsForLocation(latLng, zoomLevel);
                            this.setPosition(latLng.lat, latLng.lng, zoomLevel, bounds.south, bounds.west, bounds.north, bounds.east);
                            // since we set the position explicitly, don't center on user
                            this.communicationService.searching.shouldCenterAtUserLocation.next(false);
                            // update the map to this location
                            this.communicationService.searching.updateMap.next({ location: latLng, zoom: zoomLevel, isSearchForLocation: true });
                            return [2 /*return*/, true]; // indicate successful geocode
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    // converts the client side maps geocode to the same type as the basic server side one
    PreferencesService.prototype.getClientSideGeocode = function (searchString) {
        return __awaiter(this, void 0, void 0, function () {
            var results, isQuebec, geometry, latLng, zoomLevel, basicGeocodeResult_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.googleMapsService.performGeocode(searchString)];
                    case 1:
                        results = _a.sent();
                        if (results) {
                            isQuebec = results.some(function (r) { return r.address_components && r.address_components.some(function (c) { return 'quebec' === c.long_name.toLowerCase(); }); });
                            geometry = results[0].geometry;
                            latLng = geometry.location.toJSON();
                            zoomLevel = Helper.getZoomLevel(results[0].types);
                            basicGeocodeResult_1 = {
                                location: latLng,
                                isQuebec: isQuebec,
                                zoom: zoomLevel
                            };
                            return [2 /*return*/, new Promise(function (resolve) { return resolve(basicGeocodeResult_1); })];
                        }
                        return [2 /*return*/, new Promise(function (resolve) { return resolve(null); })];
                }
            });
        });
    };
    /**
     * Get the user's current Geolocation and set the map marker to that
     * @param shouldSkipGettingLocation whether or not we should actually retrieve their location, we would specifically skip this in the situation they land
     * on the a page that redirects the map to a specific location which has a higher precedence then the user's location such as /on/cornwall-real-estate
     * @param forceCenterLocation whether we want to explciitly call the navigator to center our location (bypass the cookie check)
     */
    PreferencesService.prototype.centerMapAtCurrentLocation = function (shouldSkipGettingLocation, forceCenterLocation) {
        var _this = this;
        if (shouldSkipGettingLocation === void 0) { shouldSkipGettingLocation = false; }
        if (forceCenterLocation === void 0) { forceCenterLocation = false; }
        if (shouldSkipGettingLocation || this.prerenderService.isServerMode) {
            this.doneGettingPhysicalLocation.next([true, true]);
            return;
        }
        // We don't want to recall the navigator if we've already fetched their location before, which will be stored in the cookie
        // The exception to this is that they manually choose to center their location via an action button on the map
        var userPosition = this.cookieService.getObject(PreferencesService.COOKIE_USER_LOCATION);
        if (userPosition && userPosition['physicalLocation'] && !forceCenterLocation) {
            var position = userPosition;
            var wcRegion = this.cookieService.get(PreferencesService.COOKIE_USER_IS_WC_REGION);
            if (!wcRegion) {
                this._handleGeoLocationByIp();
            }
            this.setPosition(position.physicalLocation.lat, position.physicalLocation.lng, position.zoomLevel);
            this.communicationService.searching.updateMap.next({ location: { lat: position.physicalLocation.lat, lng: position.physicalLocation.lng }, zoom: position.zoomLevel, isPhysical: true });
            this.doneGettingPhysicalLocation.next([true, true]);
        }
        else if (typeof navigator !== 'undefined' && navigator.geolocation) {
            // Let the subscribers know we are in the process of getting a location.
            this.doneGettingPhysicalLocation.next([false, false]);
            navigator.geolocation.getCurrentPosition(function (position) {
                // Update the placeholder for the searchbar with the area they're in.
                _this.googleMapsService.performReverseGeocode({ lat: position.coords.latitude, lng: position.coords.longitude }).then(function (results) {
                    _this.setIsWcRegion(results[0].address_components);
                    _this.communicationService.searching.activeSearchText.next(results[0].formatted_address);
                });
                _this.setPosition(position.coords.latitude, position.coords.longitude, 17);
                // Let the subscribers know we successfully got a location.
                _this.doneGettingPhysicalLocation.next([true, true]);
                _this.communicationService.searching.updateMap.next({ location: { lat: position.coords.latitude, lng: position.coords.longitude }, zoom: 17, isPhysical: true });
            }, function (error) {
                // Errors will fall here for either timeout, location not available or user denied geolocation.
                // For whatever reason we failed, so try and geolocate by IP.
                _this._handleGeoLocationByIp();
            }, { timeout: 10000, enableHighAccuracy: true, maximumAge: 60000 });
        }
        else {
            // Browser does not support geolocation, try and locate by ip
            this._handleGeoLocationByIp();
        }
    };
    PreferencesService.prototype._handleGeoLocationByIp = function () {
        var _this = this;
        this._geolocateByIp()
            .subscribe(function (success) {
            if (success) {
                // Let the subscribers know we successfully got a location.
                _this.doneGettingPhysicalLocation.next([true, true]);
            }
            else {
                // Let the subscribers know we couldn't get a location.
                _this.doneGettingPhysicalLocation.next([true, false]);
            }
        }, function (err) {
            _this.doneGettingPhysicalLocation.next([true, false]);
        });
    };
    /**
     * Attempt to call freegeoip.net to get an IP based location.
     * Their service is based on the free database provided by MaxMind, but is rate limited to 10,000 requests per hour.
     * We only run this on a failed geolocation or if the browser doesn't support it, so we shouldn't run into the rate limit.
     * @private
     * @returns
     * @memberof PreferencesService
     */
    PreferencesService.prototype._geolocateByIp = function () {
        var _this = this;
        return this.http.get(this.apiConfig.getServerRoot(this.appConfig.urls.geo.base) + this.appConfig.urls.geo.base)
            .pipe(map(function (data) {
            if (!data || !data.result) {
                return false;
            }
            var isWCRegion = false;
            if (OARegions.indexOf(data.result.region_code.toLowerCase()) != -1) {
                isWCRegion = false;
            }
            else {
                isWCRegion = true;
            }
            _this.cookieService.put(PreferencesService.COOKIE_USER_IS_WC_REGION, isWCRegion.toString(), { expires: (1000 * 60 * 60 * 24 * 30).toString() });
            // Lower zoom since IP location is not very accurate.
            _this.userService.saveUserPreferences(_this._user.preferences);
            _this.setPosition(data.result.latitude, data.result.longitude, 12);
            _this.communicationService.searching.updateMap.next({ location: PositionInfo.getCenter(_this._user.preferences.positionInfo), zoom: _this._user.preferences.positionInfo.zoomLevel, isPhysical: true });
            return true;
        }, function (error) {
            return false;
        }));
    };
    PreferencesService.prototype.getPosition = function () {
        return this._user.preferences.positionInfo;
    };
    PreferencesService.prototype.getOfficeSearchFilters = function () {
        return this._subjects.officeSearchFilters.value;
    };
    PreferencesService.prototype.getIsWcRegion = function () {
        var wcRegion = this.cookieService.get(PreferencesService.COOKIE_USER_IS_WC_REGION);
        return wcRegion && wcRegion === 'false' ? false : true;
    };
    /**
     * Takes in position info and updates the user preferences with the new position.
     * This will invoke all subscribers to the positionInfo to get an update with the new position.
     * @memberof PreferencesService
     */
    PreferencesService.prototype.setPosition = function (lat, lng, zoomLevel, south, west, north, east) {
        var newPosition = this._user.preferences.positionInfo;
        // By setting centerLatLng, the map will move to be centered on us.
        newPosition.centerLatLng = {
            lat: lat,
            lng: lng
        };
        newPosition.defaultPosition = false;
        // We set the physical location to keep track of us even if the map moves later on.
        // TODO: is this being used correctly it is being set whenever this is called?
        newPosition.physicalLocation = {
            lat: lat,
            lng: lng
        };
        newPosition.zoomLevel = zoomLevel;
        if (south)
            newPosition.south = south;
        if (west)
            newPosition.west = west;
        if (north)
            newPosition.north = north;
        if (east)
            newPosition.east = east;
        this.saveUserPosition(newPosition);
        this.cookieService.putObject(PreferencesService.COOKIE_USER_LOCATION, newPosition);
    };
    PreferencesService.prototype.getNeighbourhoodData = function (id) {
        var params = new HttpParams();
        var base = this.apiConfig.getServerRoot(this.appConfig.urls.demographics.neighbourhoodId);
        var route = this.appConfig.urls.demographics.neighbourhoodId + "/" + id;
        var hashKey = this._cache.getRequestHash(route, params);
        var hashValue = this._cache.get(hashKey);
        if (hashValue) {
            return of(new NeighbourhoodDetails(hashValue));
        }
        return this.http.get(base + route, { withCredentials: false }).pipe(map(function (data) { return new NeighbourhoodDetails(data.result); }));
    };
    PreferencesService.prototype.addNewSavedSearch = function (name, notification, index, listing) {
        var _this = this;
        if (index === void 0) { index = -1; }
        var neighbourhoodRegex = /-real-estate-guide-([\w\d_]+)$/;
        var newSearch = new SavedSearch();
        newSearch.name = name;
        newSearch.notificationsEnabled = notification;
        newSearch.notificationsFrequency = NotificationFrequency.DAILY;
        if (listing != null) {
            return new Promise(function (resolve, reject) {
                var matches = listing.neighbourhood ? neighbourhoodRegex.exec(listing.neighbourhood.detailUrl) : null;
                // try to fetch neighbourhood data from listing if neighbourhood data exists
                // there are listings without neighbourhood data
                var neighbourhoodSearchSubscription = matches && matches.length !== 0 ? _this.getNeighbourhoodData(matches[1]) : of(null);
                neighbourhoodSearchSubscription.subscribe(function (neighbourhoodDetails) {
                    newSearch.filters = Filters.clone(_this._user.preferences.filters);
                    newSearch.positionInfo = new PositionInfo();
                    newSearch.listingCategory = _this.communicationService.listings.currentShownListingType.value;
                    // if neighbourhoodDetails exists, set bounds to neighbouhood, else set zoom level to 18
                    if (neighbourhoodDetails) {
                        newSearch.positionInfo.setProperties(listing.lat, listing.lng, neighbourhoodDetails.bounds, listing.lat, listing.lng);
                    }
                    else {
                        newSearch.positionInfo.centerLatLng = { lat: listing.lat, lng: listing.lng };
                        newSearch.positionInfo.physicalLocation = { lat: listing.lat, lng: listing.lng };
                        newSearch.positionInfo.zoomLevel = 18;
                    }
                    _this.googleMapsService.performReverseGeocode(newSearch.positionInfo.centerLatLng).then(function (r) {
                        if (!r)
                            reject();
                        else {
                            var result = _this.googleMapsService.getLocationTypeFromZoomLevel(newSearch.positionInfo.zoomLevel, r);
                            if (result.types.indexOf('establishment') >= 0)
                                newSearch.nearby = result.address_components[0].long_name;
                            else
                                newSearch.nearby = result.formatted_address;
                            var searches = _this._user.preferences.savedSearches;
                            if (index >= 0)
                                searches[index] = newSearch;
                            else
                                searches.push(newSearch);
                            _this._subjects.savedSearches.next(searches);
                            resolve(newSearch);
                        }
                    });
                });
            });
        }
        else {
            newSearch.filters = Filters.clone(this._user.preferences.filters);
            newSearch.positionInfo = PositionInfo.clone(this._user.preferences.positionInfo);
            newSearch.listingCategory = this.communicationService.listings.currentShownListingType.value;
            return new Promise(function (resolve, reject) {
                _this.googleMapsService.performReverseGeocode(newSearch.positionInfo.centerLatLng).then(function (r) {
                    if (!r)
                        reject();
                    else {
                        var result = _this.googleMapsService.getLocationTypeFromZoomLevel(newSearch.positionInfo.zoomLevel, r);
                        if (result.types.indexOf('establishment') >= 0)
                            newSearch.nearby = result.address_components[0].long_name;
                        else
                            newSearch.nearby = result.formatted_address;
                        var searches = _this._user.preferences.savedSearches;
                        if (index >= 0)
                            searches[index] = newSearch;
                        else
                            searches.push(newSearch);
                        _this._subjects.savedSearches.next(searches);
                        resolve(newSearch);
                    }
                });
            });
        }
    };
    ;
    // TODO: IS there a better way to do this
    PreferencesService.prototype.setUserPreferencesFromServer = function () {
        // console.log('preferences.service: setting preferences from server');
        var s = this._user.preferences;
        // Need to do follow this to update observables properly
        this.setLocale(s.locale);
        // If its Google Bot we want to render in gallery mode because it'll take too long for the google bot to see the map and render the listings before indexing
        this.setViewModes(this.prerenderService.isBrowserMode && !this.userService.isGoogleBot() ? s.viewMode : ViewModes.GALLERY);
        this.setGallerySorting(s.gallerySorting);
        this.updateFilters(s.filters);
        this.updateSearchFilters(SearchType.AGENT, s.agentSearchFilters);
        this.updateSearchFilters(SearchType.OFFICE, s.officeSearchFilters);
        if (s.positionInfo) {
            this.communicationService.searching.updateMap.next({ location: PositionInfo.getCenter(s.positionInfo), zoom: s.positionInfo.zoomLevel });
        }
        this.saveUserPosition(s.positionInfo);
        this._addAllFavouriteListings(s.favouriteListings || []);
        this._addAllRecentSearches(s.recentSearches || []);
        this._addAllSavedSearches(s.savedSearches || []);
        this._addAllViewedListings(s.viewedListings || []);
        this._addFavouriteAgent({ favourites: (s.favouriteAgents || []), detailUrl: s.favouriteAgentDetailUrl });
    };
    PreferencesService.prototype._addAllFavouriteListings = function (favourites) {
        this._user.preferences.favouriteListings = favourites;
        this._subjects.favouriteListings.next(favourites);
    };
    PreferencesService.prototype._addFavouriteAgent = function (data) {
        this._user.preferences.favouriteAgents = data.favourites;
        this._user.preferences.favouriteAgentDetailUrl = data.detailUrl;
        this._subjects.favouriteAgents.next(data.favourites);
        this._subjects.favouriteAgentDetailUrl.next(data.detailUrl);
    };
    PreferencesService.prototype._addAllSavedSearches = function (savedSearches) {
        var localSavedSearches = this.userService.getLocalSavedSearches();
        if (localSavedSearches && localSavedSearches.length !== 0 && this._user.email) {
            this.addLocalSavedSearches(savedSearches, localSavedSearches);
        }
        else {
            this._user.preferences.savedSearches = savedSearches;
            this._subjects.savedSearches.next(savedSearches);
        }
    };
    PreferencesService.prototype.addLocalSavedSearches = function (savedSearches, localSS) {
        savedSearches.forEach(function (savedSearch, ssIndex) {
            var index = localSS.findIndex(function (s) { return s.name === savedSearch.name; });
            if (index >= 0) {
                savedSearches[ssIndex] = localSS[index];
                localSS = localSS.filter(function (ss) { return ss.name !== savedSearch.name; });
            }
        });
        savedSearches = savedSearches.concat(localSS);
        this._user.preferences.savedSearches = savedSearches;
        // this.userService.saveUserPreferences(this._user.preferences);
        this.savedLocalSavedSearches.next(true);
        this._subjects.savedSearches.next(savedSearches);
    };
    PreferencesService.prototype._addAllRecentSearches = function (recentSearches) {
        this._user.preferences.recentSearches = recentSearches;
        this._subjects.recentSearches.next(recentSearches);
    };
    /**
     * this method is called when the user first loads the app
     * we'll go through all the viewed listings and purge the ones that are older than 30 days
     * @param {string[]} viewedListings
     * @private
     */
    PreferencesService.prototype._addAllViewedListings = function (viewedListings) {
        viewedListings = viewedListings.filter(function (item) {
            var viewedDate = Number(item.split(';')[1]);
            return viewedDate >= Date.now() - THIRTY_DAYS_IN_MS;
        });
        this._user.preferences.viewedListings = viewedListings;
        this._subjects.viewedListings.next(viewedListings);
    };
    PreferencesService.COOKIE_USER_LOCATION = 'remaxca-user-location';
    PreferencesService.COOKIE_USER_IS_WC_REGION = 'wc-region';
    return PreferencesService;
}(HasSubscriptions));
export { PreferencesService };
